import React from 'react';
import CustomerLogo from '../CampaignLogo/CampaignLogo';
import CustomerLogoImage from '../../assets/images/logo-brand-customer.svg';
import FooterMenu from '../Navigation/FooterMenu/FooterMenu';
import classes from './Footer.module.scss';

import {Container, Row, Col} from 'reactstrap';

const FooterContent = (props) => (
    <Row className={classes.Footer}>
        <Col lg="2" className="d-flex align-items-center order-last order-lg-first py-3">
            <CustomerLogo
                linkUrl={process.env.REACT_APP_CUSTOMER_URL}
                src={CustomerLogoImage}/>
        </Col>

        <Col lg="10"
             className="d-flex align-items-center justify-content-lg-end justify-content-start order-first order-lg-last">
            <FooterMenu secondaryNavigation={props.secondaryNavigation}/>
        </Col>
    </Row>
);

const footer = (props) => (
    <>
        {props.contained
            ? <Container><FooterContent {...props}/></Container>
            : <FooterContent {...props}/>
        }
    </>
);

export default footer;
